import { FC } from 'react';

import { Formik } from 'formik';
import useModal from 'ui/partials/Modal/useModal';
import { type FormikHelpers } from 'formik';

import { useMoveDeals } from '../hooks';
import { DEAL_MOVE_FORM, DEAL_MOVE_SCHEMA } from '../forms/schema';
import DealMoveForm from '../forms/DealMoveForm';

type DealsMoveModalProps = {
  dealIds: string[];
  setSelectedDeals: React.Dispatch<React.SetStateAction<string[]>>;
};

const DealsMoveModal: FC<DealsMoveModalProps> = ({
  dealIds,
  setSelectedDeals,
}) => {
  const { hideModal } = useModal();
  const { mutate: moveDeals, isLoading: moveDealLoading } = useMoveDeals();

  const onSubmit = (
    values: DEAL_MOVE_FORM,
    { setSubmitting, resetForm }: FormikHelpers<DEAL_MOVE_FORM>,
  ) => {
    moveDeals(
      {
        dealIds,
        pipelineId: values.pipelineId as string,
        stageId: values.stageId as string,
      },
      {
        onSuccess: () => {
          setSelectedDeals?.([]);
          resetForm();
          hideModal();
        },
        onSettled: () => {
          setSubmitting(false);
        },
      },
    );
  };
  return (
    <Formik<DEAL_MOVE_FORM>
      initialValues={{ pipelineId: undefined, stageId: undefined }}
      onSubmit={onSubmit}
      validationSchema={DEAL_MOVE_SCHEMA}
      enableReinitialize
    >
      {() => <DealMoveForm isLoading={moveDealLoading} />}
    </Formik>
  );
};

export default DealsMoveModal;
